// extracted by mini-css-extract-plugin
export default {"viewMoreButton":"ViewMoreButton_viewMoreButton__id8+Y"};